import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { Button, ButtonBase, List, ListItem, ListItemAvatar, ListItemText, Stack } from '@mui/material';
import Badge from '@mui/material/Badge';
import { Gauge } from '@mui/x-charts';
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { useNavigate } from 'react-router-dom';
const API = require("../../data/network/API");


const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));

export default function Profile() {
  const signOut = useSignOut()
  const navigate = useNavigate();

  const [user, setUser] = React.useState(JSON.parse(localStorage.getItem("signin-data")).usuario);
  const [quizzes, setQuizzes] = React.useState(null);
  const [polls, setPolls] = React.useState(null);
  const [roulettes, setRoulettes] = React.useState(null);
  
  const logout = ()=>{
    signOut()
    navigate('/log-in')
  }

  const onRoulettes = ()=>{
    navigate('activities',{state: roulettes})
  }
  const onQuizzes = ()=>{
    navigate('activities',{state: quizzes})
  }
  const onPolls = ()=>{
    navigate('activities',{state: polls})
  }

  const getMyQuizzes = async () => {
    const queryParams = {
      id_usuario: user.firestore_id, 
    }
    const response = await API.getMyQuizzes(queryParams)
    if(response.status == 200){
      setQuizzes(response.data)
      console.log(response.data)
    }else{

    }
  }

  const getMyPolls = async () => {
    const queryParams = {
      id_usuario: user.firestore_id, 
    }
    const response = await API.getMyPolls(queryParams)
    if(response.status == 200){
      setPolls(response.data)
    }else{

    }
  }

  const getMyRoulettes= async () => {
    const queryParams = {
      id_usuario: user.firestore_id, 
    }
    const response = await API.getMyRoulettes(queryParams)
    if(response.status == 200){

      setRoulettes(response.data)
    }else{

    }
  }

  React.useEffect(()=>{
    const signin_data = localStorage.getItem("signin-data");
    const data = JSON.parse(signin_data);
    setUser(data.usuario)

    getMyQuizzes()
    getMyRoulettes()
    getMyPolls()
  },[])

  return (
    <Box sx={{ flexGrow: 1, overflow: 'hidden', px: 3,mt:10 }}>    
      <div sx={{ my: 1, mx: 'auto', p: 2}}>
        <Grid container spacing={2}>
          <Grid item>
            <StyledBadge
                overlap="circular"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                variant="dot"
              >
              <Avatar 
                alt={user.perfil.nombre} 
                src="/static/images/avatar/1.jpg" 
                sx={{ width: 56, height: 56 }}
                />
             </StyledBadge>
          </Grid>
          <Grid item>
              <Stack>
                <Typography fontWeight='bolder' variant="subtitle1" component="div">
                  {user.nivel_membresia.toUpperCase()}
                </Typography>
                <Typography gutterBottom  variant="subtitle1" component="div">
                  {user.tipo_usuario} 
                </Typography>
              </Stack>
          </Grid>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Typography gutterBottom fontWeight='bolder' variant="subtitle1" component="div">
                  {user.perfil.nombre} {user.perfil.apellido_paterno}
                </Typography>
                <Typography variant="body2" gutterBottom>
                {user.correo} 
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                 {user.cliente_guna == null ? "Aun no es cliente GUNA":"No. cliente guna"+user.cliente_guna}
                </Typography>
              </Grid>
            </Grid>
            <Grid item>
              <Stack spacing={1} alignItems={"center"}>
                <Typography sx={{fontSize: 18, fontWeight: "bold", color: "#00a152"}}> Puntos</Typography>
                <Gauge width={100} height={100} value={user.perfil.membresia.puntos} />
              </Stack>
            </Grid>
          </Grid>
          <Grid item
            lg={6}
            md={6}
            sm={6}
            xl={3}
            xs={12}
          >
            <Stack spacing={1} >
              <Button  onClick={() => onPolls()} color='secondary' fullWidth>
                Mis Encuestas
              </Button>
              <Button onClick={() => onQuizzes()} color='secondary'fullWidth>
                Mis Trivias
              </Button>
              <Button onClick={() => onRoulettes()} color='secondary'fullWidth>
                Mis ruletas
              </Button>
              <Button onClick={() => logout()} color='secondary' fullWidth>
                Logout
              </Button>
            </Stack>
          </Grid>
        </Grid>

        <List sx={{ width: '100%',  }}>
          {user.perfil.membresia.beneficios.map((beneficio)=>( 
            <ListItem>
              <ListItemText primary={beneficio.titulo} secondary={beneficio.descripcion} />
            </ListItem>
          ))}
        </List>
      </div>
    </Box>
  )
}